module.exports = require("./et.d.ts");